import React from "react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";
import WelcomeInfo from "./welcomePopups/WelcomeInfo";
import AccountVerificationInfo from "./welcomePopups/AccountVerificationInfo";

import DocumentExpirationInfo from "./welcomePopups/DocumentExpirationInfo";
import BettingDisabledInfo from "./welcomePopups/BettingDisabledInfo";
import WalletGracePeriodInfo from "./welcomePopups/WalletGracePeriodInfo";
import DepositLimitInfo from "./welcomePopups/DepositLimitInfo";
import UseMarketplaceBonus from "./welcomePopups/UseMarketplaceBonus";
import { observer } from "mobx-react";
import AnnualIncomeInfo from "./welcomePopups/AnnualIncomeInfo";
import CreditRatingCheckInfo from "./welcomePopups/CreditRatingCheckInfo";
import { PopupComponentsEnum } from "../shared/PopupComponentsEnum";
import BlockPopupComponentsService from "@services/user/BlockPopupComponentsService";

export default observer(function WelcomeLoginPopup() {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	useFixBody(true, rootStore.welcomeStore.isActive);

	const componentsList = [
		!BlockPopupComponentsService.checkIfComponentBlocked(
			PopupComponentsEnum.WelcomeInfo
		) && WelcomeInfo(),

		!BlockPopupComponentsService.checkIfComponentBlocked(
			PopupComponentsEnum.DepositLimitInfo
		) && DepositLimitInfo(),

		!BlockPopupComponentsService.checkIfComponentBlocked(
			PopupComponentsEnum.AccountVerificationInfo
		) && AccountVerificationInfo(),

		!BlockPopupComponentsService.checkIfComponentBlocked(
			PopupComponentsEnum.BettingDisabledInfo
		) && BettingDisabledInfo(),

		!BlockPopupComponentsService.checkIfComponentBlocked(
			PopupComponentsEnum.WalletGracePeriodInfo
		) && WalletGracePeriodInfo(),

		!BlockPopupComponentsService.checkIfComponentBlocked(
			PopupComponentsEnum.DocumentExpirationInfo
		) && DocumentExpirationInfo(),

		!BlockPopupComponentsService.checkIfComponentBlocked(
			PopupComponentsEnum.UseMarketplaceBonus
		) && UseMarketplaceBonus(),

		!BlockPopupComponentsService.checkIfComponentBlocked(
			PopupComponentsEnum.AnnualIncomeInfo
		) && AnnualIncomeInfo(),

		!BlockPopupComponentsService.checkIfComponentBlocked(
			PopupComponentsEnum.CreditRatingInfo
		) && CreditRatingCheckInfo(),
	];

	if (!rootStore.userAuthStore.user) {
		rootStore.welcomeStore.hidePopup();
		return null;
	}

	if (componentsList.every((component) => component == null)) {
		rootStore.welcomeStore.hidePopup();
		return null;
	}

	return (
		<div className="at-welcomeModal popup popup--mega">
			<div className="popup__card popup--mega__card">
				<div className="popup__header popup__header--top">
					<div className="popup__title popup__title--vertical">
						<div className="u-mar--bottom--xtny u-type--xxlrg u-type--wgt--bold">
							{t("HOME.PROMO_OFFER.WELCOME_TITLE", {
								gp_company_placeholder: "TipWin",
							})}
							!
						</div>
						<div className="u-type--xmed u-type--wgt--regular u-color--text--secondary">
							{t("WELCOME_POPUP.INFO_TEXT_PART_1")}{" "}
							<span className="u-type--wgt--medium u-color--text--primary">
								{t("WELCOME_POPUP.INFO_TEXT_PART_2")}
							</span>
							.
						</div>
					</div>

					<button
						type="button"
						className="popup__close btn btn--square btn--square--xsml btn--primary--inverted"
						title={t("COMMON.CLOSE")}
						onClick={async () => {
							await rootStore.userAuthStore.sendWelcomeUseBonusConfirmation(
								true
							);
							rootStore.welcomeStore.hidePopup();
						}}
					>
						<i className="u-icon u-icon--tny u-icon--close" />
					</button>
				</div>
				<div className="popup__body u-padd--lrg">
					<div className="popup__section">
						<div className="popup__row row">
							{componentsList.map((component, id) => {
								return (
									<React.Fragment key={id}>
										{component}
									</React.Fragment>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});
